import React from "react";

const DetailRegister = () => {
  return <div>DetailRegister</div>;
};

export default DetailRegister;
